import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import { StarIcon, WalkingPersonIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'
import { OtoIndividualPlacement } from '../../../lib/types/models/enrollment/oto-individual-enrollments'
import InformationToolTip from '../../elements/information-tooltip'

type Props = {
  placement: OtoIndividualPlacement
}

// the first name of the youth, flagged with the same icons as the OL center enrollment list
const OtoIndividualPlacementStudentInfo = ({ placement }: Props) => {
  const { t } = useTranslate()
  const canGoOutAlone = placement.parentAuthorizedToGoOutAlone === true

  return (
    <div className="flex items-center gap-10">
      <Typography variant="secondary-body">
        {placement.childFirstName ? StringFormatter.capitalize(placement.childFirstName) : '-'}
      </Typography>
      <div className="flex items-center gap-3">
        {canGoOutAlone && (
          <InformationToolTip
            contentVariant="secondary"
            align="center"
            size="small"
            icon={
              <div className="bg-grey-light rounded-full p-1 w-fit">
                <WalkingPersonIcon color={tailwindColors.grey.DEFAULT} />
              </div>
            }
          >
            <Typography variant="label-medium" color={tailwindColors.black.DEFAULT}>
              {t('ol.center.tooltip.canGoOutAlone')}
            </Typography>
          </InformationToolTip>
        )}
        {placement.isAA && (
          <div className="bg-yellow-light rounded-full p-1 w-fit">
            <StarIcon filled color={tailwindColors.yellow.DEFAULT} />
          </div>
        )}
      </div>
    </div>
  )
}

export default OtoIndividualPlacementStudentInfo
